import { StandardProps } from "@/components/componentMap";
import { Recommendations } from "@/components/Recommendations/Recommendations";
import { NotAvailable } from "@/components/__shared__/NotAvailable/NotAvailable";
import { VariantAttributes } from "./VariantAttributes/VariantAttributes";
import { OnlineStock } from "./OnlineStock/OnlineStock";
import { AgeRestrictionMessage } from "./AgeRestrictionMessage/AgeRestrictionMessage";
import { AddToBasketESIWrapper } from "./AddToBasketESIWrapper/AddToBasketESIWrapper";
import { DeliveryThreshold } from "./DeliveryThreshold/DeliveryThreshold";
import { ShipFromStore } from "./ShipFromStore/ShipFromStore";
import { PromotionalPrompt } from "./PromotionalPrompt/PromotionalPrompt";
import { AddToBasketLocal } from "@/components/AddToBasket/AddToBasketLocal/AddToBasketLocal.tsx";

export const AddToBasket = (props: StandardProps) => {
  const { flags } = props;

  const isNonEsiAddToBasketEnabled =
    flags.isNonEsiAddToBasketEnabled?.value === true;

  return (
    <div data-component="AddToBasket" data-testid="add-to-basket-ui">
      <VariantAttributes {...props} />
      <OnlineStock {...props} />
      <AgeRestrictionMessage {...props} />
      <NotAvailable {...props} />
      <ShipFromStore {...props} />
      {isNonEsiAddToBasketEnabled ? (
        <AddToBasketLocal {...props} />
      ) : (
        <AddToBasketESIWrapper {...props} />
      )}
      <DeliveryThreshold {...props} />
      <PromotionalPrompt {...props} />
      <Recommendations
        {...props}
        configProps={{
          ...props.configProps,
          placementId: props.configProps?.oosPlacementId || "OSPStandardOos",
          maxProductsPerPage: 3,
          hideForAvailable: true,
        }}
      />
    </div>
  );
};
